import { HOSTS } from "@/constants/environment"
import { merge } from "lodash"
/**
 * 没有在 menuTree 中声明的路由，但是有高亮菜单的，在此声明
 */
interface HighlightUrlMap {
  readonly [index: string]: string[]
}

export const cms: HighlightUrlMap = {
  inquiryManagement: ["/interact/inquiry/details"],
  inquiryNotification: ["/interact/notification/clueOwner"],
  inquiryRecycle: ["/interact/recycle/inquiry"],
  product: [
    "/content/product/list",
    "/content/product/group",
    "/content/product/setting",
  ],
  productList: [
    "/content/product/new-product",
    "/content/product/product-detail",
    "/content/product/edit-product",
  ],
  productGroup: ["/content/product/edit-group", "/content/product/new-group"],
  productImport: ["/content/product/import/list"],
  content: [
    "/content/article-list",
    "/content/article-group",
    "/content/atlas-list",
    "/content/atlas-group",
    "/content/video-list",
    "/content/download-list",
    "/content/product",
    "/content/source",
  ],
  articleList: [
    "/content/article-new",
    "/content/article-detail",
    "/content/article-edit",
  ],
  articleGroup: [
    "/content/new-article-group",
    "/content/article-group-detail",
    "/content/edit-article-group",
  ],
  atlasList: [
    "/content/atlas-new",
    "/content/atlas-detail",
    "/content/atlas-edit",
  ],
  atlasGroup: [
    "/content/atlas-group-new",
    "/content/atlas-group-detail",
    "/content/atlas-group-edit",
  ],
  videoList: [
    "/content/video-create",
    "/content/video-preview",
    "/content/video-edit",
  ],
  downloadList: [
    "/content/download-create",
    "/content/download-preview",
    "/content/download-edit",
  ],
  source: [
    "/content/source/image",
    "/content/source/video",
    "/content/source/file",
  ],
  contentRecycle: [
    "/content/recycle/product",
    "/content/recycle/material",
    "/content/recycle/content",
  ],
  siteSettings: [
    "/siteSettings/domain",
    "/siteSettings/template/home",
    "/siteSettings/template/centre",
    "/siteSettings/column",
    "/siteSettings/home",
  ],
  settingsInfo: [
    "/siteSettings/info/base",
    "/siteSettings/info/company",
    "/siteSettings/info/social",
    "/siteSettings/info/share",
  ],
  settingsTemplate: [
    "/siteSettings/template/home",
    "/siteSettings/template/centre",
  ],
  settingsDomain: ["/siteSettings/domain-bind", "/siteSettings/domain-config"],
  settingsColumn: ["/siteSettings/column/create", "/siteSettings/column/edit"],
  formManagement: ["/siteSettings/form/edit", "/siteSettings/form/create"],
  formSetting: ["/settings/form/edit", "/settings/form/create"],
  siteManagement: ["/siteSettings/siteManagement/sitemap"],
  subscribeManagement: ["/siteSettings/subscribe/setting"],
  settingsRoles: [
    "/settings/roles/newRole",
    "/settings/roles/members/:id",
    "/settings/roles/editRole",
    "/settings/roles/roleDetail",
  ],
  currentSession: ["/liveChat/session"],
  historicalSession: [
    "/liveChat/history",
    "/liveChat/history/management",
    "/liveChat/history/details",
  ],
  sessionSetting: [
    "/liveChat/setting/management",
    "/liveChat/setting/create",
    "/liveChat/setting/edit",
  ],
  settingsHome: [
    "/siteSettings/home/add-module",
    "/siteSettings/home/edit-module",
    "/siteSettings/home/module-detail",
  ],
  inquiryReport: [
    "/interact/report/daily-report",
    "/interact/report/distribution-report",
    "/interact/report/conversion-report",
  ],
}

export const target: HighlightUrlMap = {
  overview: [
    "/siteReport/overview",
    "/siteReport/visitorRegionList",
    "/siteOptimize/pageDetect",
    "/siteOptimize/seoDetect",
  ],
  adReport: [
    "/googleAds/report",
    "/googleAds/report/overview",
    "/googleAds/report/details",
    "/googleAds/advice",
    "/googleAds/payback",
    "/googleAds/gadList",
    "/googleAds/searchKeywordList",
    "/googleAds/countryRegionSpendList",
  ],
  adAccountManage: ["/googleAds/accountManage/tracking"],
}

function mergeUrlMap(cms: HighlightUrlMap, target: HighlightUrlMap) {
  const handleBaseUrl = (everySystemMap: HighlightUrlMap, baseUrl: string) =>
    Object.entries(everySystemMap).reduce((map, [menuId, highlightUrls]) => {
      return {
        ...map,
        [menuId]: highlightUrls.map(item => `${baseUrl}${item}`),
      }
    }, {})

  return merge(
    {},
    handleBaseUrl(target, HOSTS.TARGET),
    handleBaseUrl(cms, HOSTS.CMS),
  ) as any
}

export const mergedHighlightUrlMap = mergeUrlMap(cms, target)
